import { render, staticRenderFns } from "./InfoSolid.vue?vue&type=template&id=28254c74&"
import script from "./InfoSolid.vue?vue&type=script&lang=ts&"
export * from "./InfoSolid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports